import { Button, Grid, MenuItem } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setError } from '../../../components/alerts'
import * as Yup from 'yup'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import DateTimeField from '../../../components/DateTimeField/DateTimeField'
import DocumentField from '../../../components/DocumentField/DocumentField'

const retornaCheque = (u = []) => ({
  idControleCheque: u?.[0] || undefined,
  nrCheque: u?.[1] || '',
  dsBanco: u?.[2] || '',
  dsAgencia: u?.[3] || '',
  dsConta: u?.[4] || '',
  dsNomeEmitente: u?.[5] || '',
  cdDocumentoEmitente: u?.[6] || '',
  vlValor: u?.[7] || undefined,
  dtEmissao: u?.[8] || undefined,
  dtVencimento: u?.[9] || undefined,
  dtRecebimento: u?.[10] || undefined,
  tpStatus: u?.[11] || '',
  dsObservacoes: u?.[12] || '',
})

const validationSchema = Yup.object({
  nrCheque: Yup.string().required('Campo Obrigatório!'),
  dsBanco: Yup.string().required('Campo Obrigatório!'),
  dsNomeEmitente: Yup.string().required('Campo Obrigatório!'),
  vlValor: Yup.number().required('Campo Obrigatório!').min(0),
})

const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
    else setError(res.dsErro)
  }

  return (
    <Formik
      initialValues={retornaCheque(dados)}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, setFieldValue, values }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Field
                component={TextField}
                name="nrCheque"
                label="Número do Cheque"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Field
                component={TextField}
                name="dsBanco"
                label="Banco"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Field
                component={TextField}
                name="dsAgencia"
                label="Agência"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Field
                component={TextField}
                name="dsConta"
                label="Conta"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Field
                component={TextField}
                name="dsNomeEmitente"
                label="Nome do Emitente"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <DocumentField
                tipoDocumento={['CPF', 'CNPJ']}
                label="CPF/CNPJ do Emitente"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                value={values?.cdDocumentoEmitente}
                onChange={(v) => setFieldValue('cdDocumentoEmitente', v)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CurrencyField
                fullWidth
                variant="outlined"
                margin="dense"
                label="Valor"
                size="small"
                value={values?.vlValor}
                onChange={(v) => setFieldValue('vlValor', v)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Field
                component={DateTimeField}
                name="dtEmissao"
                label="Emissão"
                format="DD/MM/YYYY HH:mm"
                value={values?.dtEmissao}
                onChange={(v) => {
                  setFieldValue(
                    'dtEmissao',
                    v ? v.format('YYYY-MM-DD HH:mm:ss') : '',
                  )
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Field
                component={DateTimeField}
                name="dtVencimento"
                label="Vencimento"
                format="DD/MM/YYYY HH:mm"
                value={values?.dtVencimento}
                onChange={(v) => {
                  setFieldValue(
                    'dtVencimento',
                    v ? v.format('YYYY-MM-DD HH:mm:ss') : '',
                  )
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Field
                component={DateTimeField}
                name="dtRecebimento"
                label="Recebimento"
                format="DD/MM/YYYY HH:mm"
                value={values?.dtRecebimento}
                onChange={(v) => {
                  setFieldValue(
                    'dtRecebimento',
                    v ? v.format('YYYY-MM-DD HH:mm:ss') : '',
                  )
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Field
                component={TextField}
                name="tpStatus"
                label="Status"
                fullWidth
                select
                margin="dense"
                variant="outlined"
                size="small"
              >
                <MenuItem key={'0'} value={'0'}>
                  Recebido
                </MenuItem>
                <MenuItem key={'1'} value={'1'}>
                  Depositado
                </MenuItem>
                <MenuItem key={'2'} value={'2'}>
                  Compensado
                </MenuItem>
                <MenuItem key={'3'} value={'3'}>
                  Devolvido
                </MenuItem>
                <MenuItem key={'4'} value={'4'}>
                  Cancelado
                </MenuItem>
                <MenuItem key={'5'} value={'5'}>
                  Repassado
                </MenuItem>
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                rows={3}
                multiline
                name="dsObservacoes"
                label="Observações"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
